import { createContext, useContext } from 'react';

export type InfoDocParams = {
    infodoctoken?: string;
};

const InfoDocParamsContext = createContext<InfoDocParams| null>(null);

export const InfoDocParamsProvider = InfoDocParamsContext.Provider;

export function useInfoDocParams(): InfoDocParams | null {
  const params = useContext(InfoDocParamsContext);
  // if (!params) throw new Error('InfoDocParams: Can\'t Get data!');
  return params;
}
